import React from "react";
import { Card, Statistic, Typography } from "antd";

type StatCardProps = {
  title: string;
  value: number;
  subtitle?: string;
  accentColor: string;
  loading?: boolean;
};

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  accentColor,
  loading,
}) => {
  return (
    <Card
      loading={loading}
      style={{ position: "relative", overflow: "hidden", height: "100%" }}
      styles={{ body: { paddingTop: 20 } }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: accentColor,
        }}
      />
      <Statistic
        title={title}
        value={value}
        valueStyle={{ fontWeight: 700, lineHeight: 1.1, fontSize: 28 }}
      />
      {subtitle && (
        <Typography.Text type="secondary" style={{ fontSize: 12, marginTop: 4, display: "block" }}>
          {subtitle}
        </Typography.Text>
      )}
    </Card>
  );
};
